"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSignTaskDetailList = exports.getOilAllowanceList = exports.getMealAllowanceList = exports.getApprovalHistoryList = exports.getApporveDetailList = exports.getApporveDetailA03List = exports.getAllowanceRoute = exports.exportWeeklyMealAllowanceList = exports.exportWeekOilAllowanceList = exports.exportOilAllowanceList = exports.exportOilAllowanceDetailList = exports.exportMealAllowanceList = exports.allowanceSubmit = exports.allowanceSignSubmit = exports.allowanceAudit = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 12.1. (L_OIL_ALLOWANCE) pc油费补贴列表
var getOilAllowanceList = exports.getOilAllowanceList = function getOilAllowanceList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "protected/allowance/report/oilAllowanceList",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 12.2. (E_OIL_ALLOWANCE) pc油费补贴列表导出
var exportOilAllowanceList = exports.exportOilAllowanceList = function exportOilAllowanceList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/oilAllowanceExport",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    responseType: 'blob'
  });
};
var exportWeekOilAllowanceList = exports.exportWeekOilAllowanceList = function exportWeekOilAllowanceList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/weeklyOilDetailExport",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    responseType: 'blob'
  });
};
var exportOilAllowanceDetailList = exports.exportOilAllowanceDetailList = function exportOilAllowanceDetailList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/signTaskDetailExport",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    responseType: 'blob'
  });
};

// 12.3. (L_APPROVAL_HISTORY)审批历史列表
var getApprovalHistoryList = exports.getApprovalHistoryList = function getApprovalHistoryList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/approvalHistoryList",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 12.4. (L_SIGN_TASK_DETAIL)签到任务明细列表
var getSignTaskDetailList = exports.getSignTaskDetailList = function getSignTaskDetailList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/signTaskDetailList",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var getApporveDetailList = exports.getApporveDetailList = function getApporveDetailList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/approveDetailList",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};
var getApporveDetailA03List = exports.getApporveDetailA03List = function getApporveDetailA03List(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/approveDetailA03List",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 20.1. (DAILY_SIGN_CHECK_SUBMIT)检查提交审批
var allowanceSignSubmit = exports.allowanceSignSubmit = function allowanceSignSubmit(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/allowance/sign/check/submit",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 20.2. (SIGN_DRIVING_ROUTE)获取驾驶路线
var getAllowanceRoute = exports.getAllowanceRoute = function getAllowanceRoute(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/allowance/sign/route",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 20.3. (DAILY_SIGN_SUBMIT)提交审批
var allowanceSubmit = exports.allowanceSubmit = function allowanceSubmit(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/allowance/sign/submit",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// 20.4. (DAILY_SIGN_AUDIT)审批
var allowanceAudit = exports.allowanceAudit = function allowanceAudit(data, cancelToken) {
  return (0, _request.default)({
    module: 'CORE',
    url: "/protected/allowance/sign/audit",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (L_MEAL_ALLOWANCE) pc餐补津贴列表
var getMealAllowanceList = exports.getMealAllowanceList = function getMealAllowanceList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/mealAllowanceList",
    method: 'post',
    data: data,
    cancelToken: cancelToken
  });
};

// (E_MEAL_ALLOWANCE) pc餐补津贴列表导出
var exportMealAllowanceList = exports.exportMealAllowanceList = function exportMealAllowanceList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/mealAllowanceExport",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    responseType: 'blob'
  });
};
var exportWeeklyMealAllowanceList = exports.exportWeeklyMealAllowanceList = function exportWeeklyMealAllowanceList(data, cancelToken) {
  return (0, _request.default)({
    module: 'REPORT',
    url: "/protected/allowance/report/weeklyMealAllowanceExport",
    method: 'post',
    data: data,
    cancelToken: cancelToken,
    responseType: 'blob'
  });
};